<template>
	<div class="verify-email-form">
		<span class="verify-email-title">Verificar correo electrónico</span>
		<!-- <span class="verify-email-subtitle">{{ $route.params.preUsuarioId }}</span> -->
		<span class="verify-email-subtitle">Enviamos un correo electrónico a <span class="bold">{{ PreUsuarioEmail }}</span> con el código de verificación.</span>
		<div class="input-group">
			<label class="form__label" for="verificationCode">Código de verificación</label>
			<otp-input
				placeholder=""
				:digits="4"
				:isValid="true" id="verificationCode" name="verificationCode"
				:isDisabled="submitingForm"
				@on-complete="codigoActivacionCompleted"
				@on-changed="codigoActivacionUpdated"
				@on-paste="codigoActivacionCompleted"
			>
				<template #errorMessage>El código no es correcto</template>
			</otp-input>
			<!-- <CodeInput :loading="false" id="verificationCode" name="verificationCode" class="input" v-on:keyup.enter="alert('adsf')" @complete="codigoActivacionCompleted" @change="codigoActivacionUpdated" /> -->
		</div>
		<div class="error-area" v-if="verificationError">
			<span>{{ verificationError }}</span>
		</div>
		<button @click.prevent="verifyEmail()" :disabled="submitingForm || codigoActivacion === null">Completar registro</button>
		<span class="verify-email-send-again">¿No te llegó el correo? <a @click.prevent="reenviarEmail()" class="link-underlined">Volver a enviar</a></span>
	</div>
</template>

<script>
	import axios from 'axios';
	import OtpInput from 'otp-input-vue2';
	// import CodeInput from "vue-verification-code-input";

	export default {
		name: 'verify-email-form',
		data(){
			return {
				submitingForm: false,
				verificationError: null,
				PreUsuarioEmail: null,
				codigoActivacion: null
			}
		},
		components: {
			// CodeInput
			OtpInput
		},
		metaInfo: {
			title: 'Verificar correo electrónico',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.verifyUser();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			async verifyUser(){
				if(this.$route.params.preUsuarioId && this.$route.params.preUsuarioId.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') !== null){
					try {
						let response = await axios.post('/WSRegistroVerificarEmailValidar', {
							PreUsuarioId: this.$route.params.preUsuarioId
						});

						if(response.data.ErrorCod === 0){
							this.PreUsuarioEmail = response.data.PreUsuarioEmail
						} else {
							if(response.data.ErrorCod === 21){
								// Código ya verificado
								this.$store.dispatch('showError', response.data.ErrorDsc)
								this.$router.push({ name: 'login' })
							} else {
								this.$store.dispatch('showError', response.data.ErrorDsc)
								this.$router.push({ name: 'register' })
							}
						}
					} catch (error) {
						this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a registrarte.')
						this.$router.push({ name: 'register' })
					}
				} else {
					this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a registrarte.')
					this.$router.push({ name: 'register' })
				}
			},
			async verifyEmail(){
				this.$store.dispatch('cargando', true);
				this.submitingForm = true;

				if(this.codigoActivacion){
					try {
						let response = await axios.post('/WSRegistroVerificarEmail', {
							PreUsuarioId: this.$route.params.preUsuarioId,
							CodigoActivacion: this.codigoActivacion
						});

						if(response.data.ErrorCod === 0){
							let user = response.data.Usuario;
							this.$store.dispatch('AuthModule/loginAuto', { Usuario: user, OrganizadorActivo: null });
							this.$store.dispatch('showSuccess', 'Cuenta creada correctamente. ¡Bienvenido!')
							this.$router.push({ name: 'home', params: { 'isWelcome': true } })
						} else {
							if(response.data.ErrorCod === 31){
								this.codigoActivacion = null
								this.$store.dispatch('showError', response.data.ErrorDsc)
								let inputs = this.$el.querySelectorAll('#verificationCode input')

								inputs.forEach((i, index) => {
									i.value = ''
									i.dispatchEvent(new Event('input'));
								});
							} else {
								if(response.data.ErrorCod === 21){
									// Código ya verificado
									this.$store.dispatch('showError', response.data.ErrorDsc)
									this.$router.push({ name: 'login' })
								} else {
									this.$store.dispatch('showError', response.data.ErrorDsc)
									this.$router.push({ name: 'register' })
								}
							}
						}

						this.submitingForm = false;
						this.$store.dispatch('cargando', false);
					} catch (error) {
						this.submitingForm = false;
						this.$store.dispatch('cargando', false);
						this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a registrarte.')
						this.$router.push({ name: 'register' })
					}
				} else {
					this.submitingForm = false;
					this.$store.dispatch('cargando', false);
					this.$store.dispatch('showError', 'El código de activación no puede ser vacío.')
				}
			},
			async codigoActivacionCompleted(v){
				this.codigoActivacion = v
				await this.verifyEmail();
			},
			async codigoActivacionUpdated(){
				this.codigoActivacion = null
			},
			async reenviarEmail(){
				try {
					this.$store.dispatch('cargando', true);

					let response = await axios.post('/WSRegistroReenviarVerificacion', {
						PreUsuarioId: this.$route.params.preUsuarioId
					})

					if(response.data.ErrorCod === 0){
						// Envio exitoso
						this.$store.dispatch('showSuccess', 'Correo enviado correctamente.')
						await this.verifyUser();
					} else {
						if(response.data.ErrorCod === 20){
							this.$store.dispatch('showError', 'No se pudo enviar el correo, alcanzaste la cantidad máxima de envios.')
						} else {
							this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a registrarte.')
							this.$router.push({ name: 'register' })
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a registrarte.')
					this.$router.push({ name: 'register' })
				} finally {
					this.$store.dispatch('cargando', false);
				}
			}
		}
	}
</script>

<style lang="scss">
	div.vue-otp-input{
		width: 100% !important;
	}

	div.vue-otp-input>div.defualt-wrapper-separate{
		gap: 16px !important;
	}

	div.vue-otp-input>div.otp-wrapper>input.defualt-input-separate{
		width: 25% !important;
		height: 70px !important;
		font-size: 30px !important;
		font-family: var(--font-sora) !important;
		font-weight: var(--fw-700) !important;
		line-height: 1em !important;
		// border: none !important;
	}

	// div.vue-otp-input>div.otp-wrapper>input.defualt-active-input{
	// 	border: none !important;
	// 	box-shadow: #222 0px 0px 0px 1px inset !important;
	// }

</style>

<style lang="scss" scoped>
	.verify-email-form{
		width: 100%;
		padding: 0px;
		@include flex(column, center, flex-start);

		.verify-email-title{
			font-family: var(--font-sora);
			font-weight: var(--fw-700);
			font-size: 26px;
			margin-bottom: 5px;
		}

		.verify-email-subtitle{
			font-weight: var(--fw-400);
			font-size: 14px;
			margin-bottom: 15px;
			line-height: 1.6em;

			.bold{
				font-weight: var(--fw-600);
			}
		}

		.verify-email-send-again{
			font-weight: var(--fw-400);
			font-size: 13px;
			margin-bottom: 15px;
			line-height: 1.6em;
			text-align: center;
			width: 100%;

			a {
				margin-left: 5px;
			}
		}

		.input-group{
			width: 100%;
			margin: 12px 0px 10px 0px;
			position: relative;
			@include flex(column, flex-end, flex-start);

			label{
				font-size: 13px;
				font-weight: var(--fw-600);
				margin-top: 0px;
				margin-bottom: 8px;
				line-height: 1em;
			}

			input{
				-webkit-appearance: none;
				appearance: none;
				border: none;
				width: 100%;
				padding: 0px 36px 0px 14px;
				font-size: 14px;
				font-weight: var(--fw-400);
				line-height: 1.4em;
				width: 100%;
				border: none;
				border-radius: 8px;
				height: 44px;
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
				// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

				&::placeholder {
					color: #9aa5b5;
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: #9aa5b5;
				}

				&::-ms-input-placeholder {
					color: #9aa5b5;
				}

				&:focus-within {
					@include transition(all .2s);
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset;

					&.form-input--error{
						box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
					}
				}

				&.form-input--error{
					box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
				}
			}

			input:-webkit-autofill,
			input:-webkit-autofill:hover, 
			input:-webkit-autofill:focus,
			textarea:-webkit-autofill,
			textarea:-webkit-autofill:hover,
			textarea:-webkit-autofill:focus,
			select:-webkit-autofill,
			select:-webkit-autofill:hover,
			select:-webkit-autofill:focus {
				border: none;
				-webkit-text-fill-color: var(--color-darker);
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;
				-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;

				&:focus-within {
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px var(--color-white) inset;
				}
			}

			.input-icon{
				position: absolute;
				color: rgb(176, 176, 176);
				bottom: 12px;
				font-size: 20px;
				right: 12px;
				cursor: pointer;

				&:hover{
					@include transition(all .2s);
					color: var(--color-darker);
				}
			}

			&.form-group--error{
				label{
					color: var(--color-red-error);
				}
			}
		}

		.error-group{
			width: 100%;
			@include flex(column, center, flex-start);

			.error{
				font-size: 11px;
				color: var(--color-red-error);
				line-height: 1em;
			}
		}

		button{
			background-color: #222222;
			border: none;
			border-radius: 8px;
			outline: none;
			padding: 14px;
			width: 100%;
			color: var(--color-white);
			font-size: 15px;
			font-weight: var(--fw-600);
			font-family: var(--font-sora);
			line-height: 1.4em;
			letter-spacing: 1px;
			margin-top: 14px;
			margin-bottom: 14px;
			@include transition(all .2s);
			cursor: pointer;

			&:hover{
				background-color: var(--color-black);
			}

			&:disabled{
				opacity: 0.1;
				cursor: not-allowed;
			}
		}

		.error-area{
			width: 100%;
			@include flex(row, flex-start, center);
			padding: 12px;
			margin-top: 10px;
			border-radius: 8px;
			background: rgb(255, 243, 243);

			span{
				color: rgb(242, 53, 53);
				font-size: 14px;
				font-weight: var(--fw-500);
			}
		}

		p{
			font-weight: var(--fw-400);
			font-size: 14px;
			text-align: center;
			width: 100%;
			margin-top: 15px;

			a{
				margin-left: 5px;
				color: var(--color-primary);
			}
		}
	}
</style>